// @ts-nocheck

import React from 'react';
import styled, { css, keyframes } from 'styled-components';

import theme from '../../../styled-components/dark';
import { KLBorderSvg, KLFullSvg } from '../assets/svg';

const Wrapper = styled.div`
  width: 2em;
  height: 2em;
  margin: 0;
  padding: 0;

  position: relative;
  overflow: hidden;
`;

const sharedIconStyle = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: 100%;
`;

const StyledBorderSvg = styled(KLBorderSvg)`
  ${sharedIconStyle}

  z-index: 3;
`;

const StyledFullSvg = styled(KLFullSvg)`
  ${sharedIconStyle}

  z-index: 1;
`;

const GAP_RATIO = 20; // %
const ANIMATION_DURATION = 3000; // ms

const translation = keyframes`
  0% {
    transform: translate3d(0%, 0%, 0) rotate(45deg);
  }

  10% {
    transform: translate3d(0%, 0%, 0) rotate(45deg);
  }

  90% {
    transform: translate3d(-480%, 480%, 0) rotate(45deg);
  }

  100% {
    transform: translate3d(-480%, 480%, 0) rotate(45deg);
  }
`;

const FlashingMask = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  left: 0;
  top: 0;
  z-index: 2;
  opacity: 1;
  transition: opacity 300ms ease-in-out;
  transform: translate3d(0%, 0%, 0);

  ${({ $shouldDisplay, $disableAnimation }) => {
    if (!$shouldDisplay) {
      return css`
        opacity: 0;
      `;
    }

    if (!$disableAnimation) {
      return css`
        animation: ${translation} ${ANIMATION_DURATION}ms ease-in-out infinite;
      `;
    }
  }}
`;

const FlashMask = styled.div`
  position: absolute;
  width: 100%;
  left: 0;

  transition-property: background;
  transition-timing-function: var(--mask-transition-timing-function, ease-in-out);
  transition-duration: var(--mask-transition, 300ms);
  background: var(--mask-bg, ${theme.TabBar.backgroundColor});

  ${({ $i }) => css`
    height: ${$i === 2 ? '300%' : '100%'};
    top: calc(${-$i * (100 + GAP_RATIO)}% - ${$i > 1 ? 200 : 0}%);
  `}
`;

type KLIconProps = {
  disableAnimation?: boolean;
  isHighlight?: boolean;
  className?: string;
};

const KLIcon = ({ className = '', disableAnimation = false, isHighlight = false }: KLIconProps) => {
  return (
    <Wrapper className={className}>
      <StyledBorderSvg />
      <FlashingMask $shouldDisplay={!isHighlight} $disableAnimation={disableAnimation}>
        <FlashMask $i={0} />
        <FlashMask $i={1} />
        <FlashMask $i={2} />
        <FlashMask $i={3} />
        <FlashMask $i={4} />
      </FlashingMask>
      <StyledFullSvg />
    </Wrapper>
  );
};

export default KLIcon;
